<ng-container *transloco="let t">
    <div
        class="delete-confirmation flex flex-col gap-2.5"
        [dir]="lang === 'en' ? 'ltr' : 'rtl'"
    >
    <div class="flex items-center justify-center">
        <img
            class="dark:hidden w-14 h-14 rounded-full object-contain"
            src="../../../../../assets/images/logo/logo-text.png"
            [alt]="t('Logo')"
        />
        <img
            class="hidden dark:inline w-14 h-14 rounded-full object-contain"
            src="../../../../../assets/images/logo/logo-text-dark.png"
            [alt]="t('Logo')"
        />
    </div>

    <ng-container *ngIf="data.from === 'chat'; else notChat">
        <h1
            [class]="
                'text-xl -mt-1 mb-0.5 font-semibold ' +
                (lang === 'en' ? 'text-center' : 'text-start')
            "
        >
            {{ t("Are you sure?") }}
        </h1>
        <p
            [class]="
                'text-sm text-secondary leading-relaxed ' +
                (lang === 'en' ? 'text-center' : 'text-start')
            "
        >
            {{ t(data.message) }}
        </p>
        <form
            *ngIf="data.showReason && reasonForm"
            [formGroup]="reasonForm"
            class="w-full mt-2"
        >
            <mat-form-field class="w-full fuse-mat-dense" appearance="outline">
                <mat-label>{{ t("Reason (optional)") }}</mat-label>
                <textarea
                    matInput
                    formControlName="reason"
                    rows="3"
                    [placeholder]="
                        t('Tell us why this response is incorrect')
                    "
                ></textarea>
            </mat-form-field>
        </form>
    </ng-container>

    <ng-template #notChat>
        <h1
            [class]="
                'text-xl -mt-1 mb-0.5 font-semibold ' +
                (lang === 'en' ? 'text-center' : 'text-start')
            "
        >
            {{ t("Are you sure?") }}
        </h1>
        <p
            [class]="
                'text-base leading-relaxed ' +
                (lang === 'en' ? 'text-center' : 'text-start')
            "
        >
            {{ t("Do you really want to delete") }}
            <ng-container *ngIf="data.from !== 'activity'; else activity">
                <button
                    type="button"
                    class="font-semibold copy-name-chip"
                    [title]="t('Click to copy')"
                    (click)="copyName(getConfirmName())"
                >
                    {{ getConfirmName() }}
                </button>?
            </ng-container>
            <ng-template #activity>
                <span class="font-semibold" [innerHTML]="data.name"></span>
            </ng-template>
        </p>

        <ng-container
            *ngIf="data.from === 'datasourceTables'; else normalDelete"
        >
            <p
                [class]="
                    'text-base text-secondary leading-relaxed ' +
                    (lang === 'en' ? 'text-center' : 'text-start')
                "
            >
                {{ t("This action will disable the connected form!") }}.
            </p>
        </ng-container>

        <ng-template #normalDelete>
            <p
                *ngIf="data?.isMediaContainer; else genericDeleteNotice"
                [class]="
                    'text-sm text-secondary leading-relaxed ' +
                    (lang === 'en' ? 'text-center' : 'text-start')
                "
            >
                {{ t("Remove all registered files from this Data Source before deleting it. Files in the external storage provider will not be deleted.") }}
            </p>
            <ng-template #genericDeleteNotice>
                <p
                    [class]="
                        'text-base text-secondary leading-relaxed ' +
                        (lang === 'en' ? 'text-center' : 'text-start')
                    "
                >
                    {{ t("This process can not be undone") }}.
                </p>
            </ng-template>
        </ng-template>
    </ng-template>

    <form
        *ngIf="data.from === 'datasource'"
        [formGroup]="form"
        class="w-full mt-2"
    >
        <div class="w-full">
            <mat-form-field class="w-full relative fuse-mat-dense">
                <mat-label>{{ t("Write Data Source name to delete it") }}</mat-label>
                <input
                    (input)="checkMatch($event.target.value)"
                    matInput
                    type="text"
                    [formControlName]="'name'"
                />
            </mat-form-field>
        </div>
    </form>

    <form
        *ngIf="requiresTypedNameConfirm()"
        [formGroup]="agentform"
        class="w-full mt-2"
    >
        <div class="w-full">
            <p class="text-sm text-secondary leading-relaxed whitespace-normal break-words text-start">
                {{
                    data.from === 'organization'
                        ? t(
                              "All data belonging to this organization, including users, agents, chats, analytics, and insights, will be permanently deleted. Please write the organization name to delete it"
                          )
                        : t(
                              "All data generated by this agent, including chats, analytics, and insights, will be permanently deleted. Please write agent name to delete it"
                          )
                }}
            </p>
            <mat-form-field class="w-full relative mt-2 fuse-mat-dense">
                <input
                    (input)="checkAgentMatch($event.target.value)"
                    matInput
                    type="text"
                    [formControlName]="'name'"
                />
            </mat-form-field>
        </div>
    </form>

    <div class="buttons flex items-center gap-3 mt-1 justify-between">
        <button
            type="button"
            class="w-[48%]"
            mat-stroked-button
            color="warn-300"
            [mat-dialog-close]="false"
        >
            {{ t("Cancel") }}
        </button>
        <button
            *ngIf="data.from === 'chat' && data.showReason; else standardConfirmBtn"
            type="button"
            class="w-[48%] bg-red-600"
            mat-flat-button
            (click)="confirmChat()"
        >
            <span class="text-white">{{ t("Confirm") }}</span>
        </button>
        <ng-template #standardConfirmBtn>
            <button
                type="button"
                class="w-[48%] bg-red-600"
                mat-flat-button
                [disabled]="
                    (!match && data.from === 'datasource') ||
                    (!agentMatch && requiresTypedNameConfirm())
                "
                [mat-dialog-close]="true"
            >
                <span class="text-white">{{
                    data.from === "chat" ? t("Confirm") : t("Delete")
                }}</span>
            </button>
        </ng-template>
    </div>
    </div>
</ng-container>
